import React, { useState } from 'react';
import './App.css';
import { Box } from './components/Box';
import { BoxRow } from './components/BoxRow';
import { CarInput } from './components/CarInput';
import { Car } from './types/CarTypes';
import { determineGameNumber, evaluateGuess, initialiseGame, startGame, updateGame } from './game';
import { Field, Game, Outcome } from './types/GameTypes';
import { allCars } from './data';
import { HelpOverlay } from './components/overlays/HelpOverlay';
import { ResultOverlay } from './components/overlays/ResultOverlay';
import { WelcomeOverlay } from './components/overlays/WelcomeOverlay';
import { AboutOverlay } from './components/overlays/AboutOverlay';
import ReactGA from "react-ga4";
import useCookie from "react-use-cookie";
import { mergeIntoStatsCookieString, buildStat, STATS_COOKIE_NAME } from './cookies';

let randIndex;
let gameNumber:number = 0;
const today = new Date();
if (window.location.hash === "#beta") {
  randIndex = Math.floor(Math.random() * allCars.length);
  gameNumber = randIndex;
  console.log(`beta mode game ${gameNumber}`)
} else {
  [randIndex, gameNumber] = determineGameNumber(today)
}

const targetCar = allCars[randIndex];

const renderRound = (round: Outcome, index: number, onClick: (field: Field) => void, guess?: Car) => {
  return (
    <BoxRow key={`row-${index}`}>
      <Box
        key={`row${index}-manufacturer-${round.manufacturer}`}
        mode={round.manufacturer} 
        field="manufacturer"
        onClick={onClick}
        mainText={guess?.manufacturer.name || ''} 
        subText={guess?.manufacturer.parent?.name} />
      <Box 
        key={`row${index}-model-${round.model}`}
        mode={round.model} 
        field="model"
        onClick={onClick}
        mainText={guess?.model || ''} />
      <Box 
        key={`row${index}-bodyStyle-${round.bodyStyle}`}
        mode={round.bodyStyle} 
        field="bodyStyle"
        onClick={onClick}
        mainText={guess?.bodyStyle.name || ''} 
        subText={guess?.bodyStyle.family} />
      <Box 
        key={`row${index}-madeIn-${round.madeIn}`} 
        mode={round.madeIn}
        field="madeIn"
        onClick={onClick}
        mainText={guess?.manufacturer.country.name || ''}
        subText={guess?.manufacturer.country.continent} />
      <Box 
        key={`row${index}-poweredBy-${round.poweredBy}`}
        mode={round.poweredBy} 
        field="poweredBy"
        onClick={onClick}
        mainText={guess?.poweredBy || ''} />
   </BoxRow>
  );
}

const renderGame = (game: Game, onClick: (field: Field) => void) => {
  return game.outcomes.map((round, index) => {
    let guess;
    if (index <= game.round) {
      guess = game.guesses[index];
    }
    return renderRound(round, index, onClick, guess);
  });
}

function App() {
  const [showAbout, setShowAbout] = useState(false);
  const [game, setGame] = useState<Game>(initialiseGame)
  const [helpField, setHelpField] = useState<Field | undefined>(undefined)
  const [statsCookie, setStatsCookie] = useCookie(STATS_COOKIE_NAME);

  const updateStats = (finishedGame: Game) => {
    const stat = buildStat(finishedGame, gameNumber);
    setStatsCookie(mergeIntoStatsCookieString(statsCookie, stat));
  }

  const onCarSelected = (car: Car) => {
    const outcome = evaluateGuess(targetCar, car);
    const updatedGame = updateGame(game, outcome, car);
    if (updatedGame.gameResult === "Won") {
      updateStats(updatedGame);
      // updateAchievements(updatedGame);
    }
    if (updatedGame.gameResult === "Lost") {
      updateStats(updatedGame);
    }
    setGame(updatedGame);
  }

  const onBoxClicked = (field: Field) => {
    setHelpField(field);
  }

  const onWelcomeOverlayDismissed = () => {
    const updatedGame = startGame(game);
    setGame(updatedGame);
    ReactGA.initialize("G-0WWFKN7WNR");
    ReactGA.send("pageview");
  }

  return (
    <article className="clamped-width">
      <div className="AboutIcon" onClick={() => setShowAbout(true)}>♡</div>
      {showAbout && <AboutOverlay onDismissed={() => setShowAbout(false)}/>}
      <div className="spacer"></div>
      {game.gameResult === "NotStarted" &&
        <WelcomeOverlay onDismissed={onWelcomeOverlayDismissed}/>
      }
      <ResultOverlay 
        game={game} 
        gameNumber={gameNumber}
        targetCar={targetCar} 
        onDismissed={onWelcomeOverlayDismissed} />
      <BoxRow key="header" header>
        <div className="BoxRowHeader" onClick={() => onBoxClicked("manufacturer")}>Make</div>
        <div className="BoxRowHeader" onClick={() => onBoxClicked("model")}>Model</div>
        <div className="BoxRowHeader" onClick={() => onBoxClicked("bodyStyle")}>Body</div>
        <div className="BoxRowHeader" onClick={() => onBoxClicked("madeIn")}>Origin</div>
        <div className="BoxRowHeader" onClick={() => onBoxClicked("poweredBy")}>Power</div>
      </BoxRow>
      <HelpOverlay field={helpField} onDismissed={() => setHelpField(undefined)}/>
      {renderGame(game, onBoxClicked)}
      <div className="spacer"></div>

      <CarInput options={allCars} onCarSelected={onCarSelected} disabled={game.gameResult === "Lost" || game.gameResult === "Won"}></CarInput>
    </article>
  );
}

export default App;

